export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  slug: string;
  chapters: number;
  rating: number;
  isHot: boolean;
  isNew: boolean;
}

export const hotComics: Comic[] = [
  {
    id: 1,
    title: '我独自升级',
    author: 'Chugong / Dubu',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20powerful%20male%20warrior%20with%20dark%20hair%20and%20glowing%20blue%20eyes%2C%20anime%20art%20style%2C%20dynamic%20pose%2C%20dramatic%20lighting%20from%20behind%2C%20dark%20fantasy%20theme%2C%20digital%20illustration%20with%20clean%20background%2C%20webtoon%20cover%20aesthetic&width=400&height=560&seq=hot-comic-01&orientation=portrait',
    category: '热血',
    slug: 'action',
    chapters: 201,
    rating: 9.8,
    isHot: true,
    isNew: false,
  },
  {
    id: 2,
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20featuring%20a%20calm%20male%20protagonist%20wearing%20a%20white%20coat%20holding%20a%20book%2C%20mysterious%20atmosphere%2C%20soft%20golden%20light%2C%20fantasy%20theme%2C%20clean%20composition%2C%20digital%20illustration%2C%20Korean%20manhwa%20style&width=400&height=560&seq=hot-comic-02&orientation=portrait',
    category: '奇幻',
    slug: 'fantasy',
    chapters: 186,
    rating: 9.7,
    isHot: true,
    isNew: false,
  },
  {
    id: 3,
    title: '剑尊归来',
    author: 'Biga / LICO',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20illustration%20of%20a%20swordsman%20with%20long%20black%20hair%20in%20traditional%20martial%20arts%20robe%2C%20holding%20a%20glowing%20sword%2C%20oriental%20fantasy%20theme%2C%20dramatic%20composition%2C%20ink%20wash%20painting%20influence%2C%20digital%20art%2C%20elegant%20style&width=400&height=560&seq=hot-comic-03&orientation=portrait',
    category: '武侠',
    slug: 'martial-arts',
    chapters: 154,
    rating: 9.6,
    isHot: true,
    isNew: false,
  },
  {
    id: 4,
    title: 'SSS级重生猎人',
    author: 'Neida / Bill K.',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20art%20of%20a%20young%20male%20hunter%20with%20silver%20hair%20and%20a%20determined%20expression%2C%20wearing%20modern%20combat%20gear%2C%20dungeon%20theme%2C%20action%20pose%2C%20vibrant%20colors%2C%20digital%20illustration%2C%20manhwa%20cover%20style&width=400&height=560&seq=hot-comic-04&orientation=portrait',
    category: '热血',
    slug: 'action',
    chapters: 132,
    rating: 9.5,
    isHot: true,
    isNew: false,
  },
];

export const newComics: Comic[] = [
  {
    id: 5,
    title: '绝世神医',
    author: 'Han Yoo-rang',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20illustration%20of%20a%20handsome%20doctor%20in%20traditional%20Korean%20hanbok%20with%20medical%20tools%2C%20historical%20fantasy%20setting%2C%20soft%20warm%20lighting%2C%20romance%20theme%2C%20elegant%20composition%2C%20digital%20art%2C%20clean%20background&width=400&height=560&seq=new-comic-01&orientation=portrait',
    category: '古风',
    slug: 'martial-arts',
    chapters: 28,
    rating: 9.3,
    isHot: false,
    isNew: true,
  },
  {
    id: 6,
    title: '恶女的重生',
    author: 'Sol-leks / Ant Studio',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20featuring%20a%20beautiful%20female%20noble%20with%20long%20red%20hair%20in%20elegant%20Victorian%20style%20dress%2C%20regal%20posture%2C%20romance%20fantasy%2C%20dramatic%20lighting%2C%20manhwa%20art%20style&width=400&height=560&seq=new-comic-02&orientation=portrait',
    category: '恋爱',
    slug: 'romance',
    chapters: 45,
    rating: 9.4,
    isHot: false,
    isNew: true,
  },
  {
    id: 7,
    title: '入魔的魔法师',
    author: 'Park Jin-seok',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20art%20of%20a%20dark%20mage%20with%20purple%20energy%20surrounding%20him%2C%20wearing%20a%20dark%20robe%2C%20magical%20circles%20in%20background%2C%20dark%20fantasy%20theme%2C%20mysterious%20atmosphere%2C%20digital%20illustration%2C%20dramatic%20composition&width=400&height=560&seq=new-comic-03&orientation=portrait',
    category: '奇幻',
    slug: 'fantasy',
    chapters: 67,
    rating: 9.2,
    isHot: false,
    isNew: true,
  },
  {
    id: 8,
    title: '校园特工',
    author: 'Kim Hyun-soo',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20illustration%20of%20a%20teenage%20boy%20in%20school%20uniform%20with%20a%20cool%20expression%2C%20holding%20a%20smartphone%2C%20modern%20school%20setting%2C%20action%20comedy%20theme%2C%20bright%20colors%2C%20digital%20art%2C%20youthful%20vibe&width=400&height=560&seq=new-comic-04&orientation=portrait',
    category: '校园',
    slug: 'school',
    chapters: 89,
    rating: 9.1,
    isHot: false,
    isNew: true,
  },
];

export const categories = [
  {
    id: 1,
    name: '热血动作',
    slug: 'action',
    count: 326,
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20action%20scene%20with%20dynamic%20fighting%20pose%2C%20two%20characters%20in%20intense%20combat%2C%20speed%20lines%2C%20explosive%20effects%2C%20warm%20orange%20and%20red%20color%20palette%2C%20digital%20illustration%2C%20manhwa%20style%2C%20clean%20composition&width=600&height=600&seq=category-action&orientation=squarish',
  },
  {
    id: 2,
    name: '恋爱甜宠',
    slug: 'romance',
    count: 458,
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20scene%20with%20two%20characters%20sharing%20a%20gentle%20moment%20under%20cherry%20blossoms%2C%20soft%20pink%20and%20warm%20lighting%2C%20romantic%20atmosphere%2C%20digital%20art%2C%20manhwa%20style%2C%20sweet%20and%20tender%20mood&width=600&height=600&seq=category-romance&orientation=squarish',
  },
  {
    id: 3,
    name: '奇幻冒险',
    slug: 'fantasy',
    count: 289,
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20world%20with%20a%20magical%20landscape%2C%20floating%20islands%2C%20crystal%20towers%2C%20mystical%20creatures%2C%20warm%20golden%20and%20teal%20color%20scheme%2C%20digital%20illustration%2C%20manhwa%20style%2C%20grand%20scale&width=600&height=600&seq=category-fantasy&orientation=squarish',
  },
  {
    id: 4,
    name: '武侠江湖',
    slug: 'martial-arts',
    count: 203,
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20martial%20arts%20scene%20with%20a%20warrior%20in%20traditional%20clothing%20standing%20on%20a%20misty%20mountain%20peak%2C%20ink%20wash%20style%2C%20oriental%20aesthetic%2C%20bamboo%20forest%20background%2C%20digital%20art%2C%20elegant%20composition&width=600&height=600&seq=category-martial&orientation=squarish',
  },
  {
    id: 5,
    name: '悬疑推理',
    slug: 'mystery',
    count: 156,
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20mystery%20scene%20with%20a%20detective%20character%20in%20trench%20coat%2C%20dark%20alley%20with%20street%20lamp%2C%20noir%20atmosphere%2C%20dramatic%20shadows%2C%20digital%20illustration%2C%20manhwa%20style%2C%20suspenseful%20mood&width=600&height=600&seq=category-mystery&orientation=squarish',
  },
  {
    id: 6,
    name: '校园青春',
    slug: 'school',
    count: 278,
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20school%20life%20scene%20with%20students%20in%20uniform%20walking%20through%20a%20sunny%20campus%2C%20cherry%20blossom%20trees%2C%20youthful%20energy%2C%20bright%20and%20warm%20colors%2C%20digital%20art%2C%20manhwa%20style%2C%20fresh%20atmosphere&width=600&height=600&seq=category-school&orientation=squarish',
  },
];

export const testimonials = [
  {
    id: 1,
    name: '漫迷小王',
    role: '忠实读者',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20young%20male%20character%20portrait%2C%20friendly%20smile%2C%20casual%20hoodie%2C%20warm%20lighting%2C%20simple%20background%2C%20digital%20illustration%2C%20anime%20style&width=120&height=120&seq=avatar-01&orientation=squarish',
    content: '韩漫屋真的是我每天必逛的网站！更新速度超快，而且分类特别清楚，找漫画从来不费劲。画质也很棒，推荐给所有爱看韩漫的朋友！',
    rating: 5,
  },
  {
    id: 2,
    name: '小雅爱漫画',
    role: 'VIP用户',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20young%20female%20character%20portrait%2C%20sweet%20smile%2C%20long%20brown%20hair%2C%20soft%20pastel%20colors%2C%20simple%20background%2C%20digital%20illustration%2C%20anime%20style&width=120&height=120&seq=avatar-02&orientation=squarish',
    content: '从大学开始就在这里看漫画了，三年了从来没让我失望过。恋爱漫画资源特别全，翻译质量也很高，真的很用心！',
    rating: 5,
  },
  {
    id: 3,
    name: '剑心',
    role: '漫画达人',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20cool%20male%20character%20portrait%2C%20confident%20expression%2C%20dark%20hair%2C%20modern%20streetwear%2C%20warm%20lighting%2C%20simple%20background%2C%20digital%20illustration%2C%20anime%20style&width=120&height=120&seq=avatar-03&orientation=squarish',
    content: '热血管道太对胃口了！《我独自升级》和《剑尊归来》的更新追得停不下来。阅读体验很流畅，版面设计也很舒服。',
    rating: 5,
  },
  {
    id: 4,
    name: '漫画控七七',
    role: '资深漫迷',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20cute%20female%20character%20portrait%2C%20round%20glasses%2C%20short%20hair%2C%20warm%20smile%2C%20cozy%20sweater%2C%20simple%20background%2C%20digital%20illustration%2C%20anime%20style&width=120&height=120&seq=avatar-04&orientation=squarish',
    content: '韩漫屋的分类系统太赞了，各种题材分得清清楚楚。收藏功能也方便，把自己喜欢的漫画一网打尽，天天有惊喜！',
    rating: 5,
  },
  {
    id: 5,
    name: '追漫少年',
    role: '新用户',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20teenage%20boy%20character%20portrait%2C%20energetic%20expression%2C%20baseball%20cap%2C%20casual%20style%2C%20warm%20lighting%2C%20simple%20background%2C%20digital%20illustration%2C%20anime%20style&width=120&height=120&seq=avatar-05&orientation=squarish',
    content: '朋友推荐的韩漫屋，从此入坑出不来啦！每天都有新漫画更新，页面速度也很快。强烈推荐给刚开始看韩漫的新朋友！',
    rating: 4,
  },
];